// Bored George - Bundle App
// File: bundle-product.js

const BoredGeorgeBundle = {
  config: {
    bundlePrice: 30200,
    singlePrice: 18900,
    savings: 7500,
    bundleTag: 'sunglasses',
    excludeTag: 'outlet',
  },

  init() {
    this.bindButtons();
  },

  bindButtons() {
    const buyTwoBtn = document.getElementById('bg-buy-two');
    const buyOneBtn = document.getElementById('bg-buy-one');

    if (buyTwoBtn) {
      buyTwoBtn.addEventListener('click', () => this.openModal());
    }

    if (buyOneBtn) {
      buyOneBtn.addEventListener('click', () => this.buyOne());
    }
  },

  buyOne() {
    const variantId = document.querySelector('[name="id"]').value;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(() => {
      if (typeof window.unicornOpenCart === 'function') {
        window.unicornOpenCart();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => console.error('Error adding to cart:', err));
  },

  openModal() {
    this.fetchProducts();
    const modal = document.getElementById('bg-bundle-modal');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.closeModal();
      }
    });
  },

  closeModal() {
    document.getElementById('bg-bundle-modal').style.display = 'none';
    document.body.style.overflow = '';
  },
};

document.addEventListener('DOMContentLoaded', () => BoredGeorgeBundle.init());
// Product fetching - adds to BoredGeorgeBundle
Object.assign(BoredGeorgeBundle, {

  fetchProducts() {
    const modalGrid = document.getElementById('bg-modal-grid');
    modalGrid.innerHTML = '<p class="bg-loading">Loading styles...</p>';

    fetch('/collections/buy-2-save-75/products.json?limit=250')
      .then(res => res.json())
      .then(data => {
  const sunglasses = data.products.filter(product => {
    const tags = product.tags.map(t => t.toLowerCase());
    const hasSunglassesTag = tags.some(t => t.includes(this.config.bundleTag));
    const hasOutletTag = tags.some(t => t.includes(this.config.excludeTag));
    return hasSunglassesTag && !hasOutletTag;
  }); 

        if (sunglasses.length === 0) {
          modalGrid.innerHTML = '<p class="bg-loading">No styles found.</p>';
          return;
        }

        this.renderProducts(sunglasses);
      })
      .catch(err => {
        console.error('Error fetching products:', err);
        modalGrid.innerHTML = '<p class="bg-loading">Something went wrong. Please try again.</p>';
      });
  },

  renderProducts(products) {
    const currentProductId = parseInt(document.getElementById('bg-buy-two').dataset.productId);
    const modalGrid = document.getElementById('bg-modal-grid');
    modalGrid.innerHTML = '';

    products.forEach(product => {
      if (product.id === currentProductId) return; // exclude current product

      const variant = product.variants[0];
const image = product.images[0] ? product.images[0].src : '';
const price = parseFloat(variant.price).toFixed(2);
const bundlePrice = (parseFloat(variant.price) - 75).toFixed(2);

const card = document.createElement('div');
card.className = 'bg-product-card';
card.dataset.variantId = variant.id;
card.dataset.productTitle = product.title;
card.innerHTML = `
  <img src="${image}" alt="${product.title}" class="bg-product-image" />
  <div class="bg-product-info">
    <p class="bg-product-title">${product.title}</p>
    <p class="bg-product-price"><span class="bg-price-was">$${price}</span> <span class="bg-price-now">$${bundlePrice}</span></p>
  </div>
  <button class="bg-select-btn">Select</button>
`;

      card.querySelector('.bg-select-btn').addEventListener('click', () => {
        this.selectSecondPair(variant.id, product.title);
      });

      modalGrid.appendChild(card);
    });
  },

});
// Cart logic - adds to BoredGeorgeBundle
Object.assign(BoredGeorgeBundle, {

  selectSecondPair(secondVariantId, secondProductTitle) {
    const firstVariantId = document.querySelector('[name="id"]').value;
    this.addBundleToCart(firstVariantId, secondVariantId);
  },

  addBundleToCart(firstVariantId, secondVariantId) {
    this.closeModal();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: parseInt(firstVariantId), quantity: 1 },
          { id: parseInt(secondVariantId), quantity: 1 }
        ]
      })
    })
    .then(res => res.json())
    .then(() => {
      if (typeof window.unicornOpenCart === 'function') {
        window.unicornOpenCart();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(err => {
      console.error('Bundle cart error:', err);
    });
  },

});
// Hide/show bundle based on selected variant availability
Object.assign(BoredGeorgeBundle, {

  initVariantWatcher() {
    const bundleCard = document.getElementById('bg-buy-two');
    if (!bundleCard) return;

    const variantInput = document.querySelector('[name="id"]');
    if (!variantInput) return;

    this.updateBundleVisibility(variantInput.value);

    const observer = new MutationObserver(() => {
      this.updateBundleVisibility(variantInput.value);
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    variantInput.addEventListener('change', () => {
      this.updateBundleVisibility(variantInput.value);
    });
  },

  updateBundleVisibility(variantId) {
    const bundleCard = document.getElementById('bg-buy-two');
    if (!bundleCard || !variantId) return;

    const availabilityMap = {};
    (bundleCard.dataset.variantsAvailability || '').split(',').forEach(pair => {
      const [id, avail] = pair.split(':');
      availabilityMap[id] = avail === 'true';
    });

    const isAvailable = availabilityMap[variantId];
    bundleCard.style.display = isAvailable ? '' : 'none';
  },

});

document.addEventListener('DOMContentLoaded', () => BoredGeorgeBundle.initVariantWatcher());